import React from 'react';
import { TextVariant } from '@naf/text';
import iconMapper from './IconMapper';
import * as S from './ProductData.styles';

type ProductDataProps = {
  parameters?: { title?: string; value?: string; icon?: string }[];
};

const ProductData = ({ parameters }: ProductDataProps) => {
  if (!parameters || parameters.length === 0) {
    return null;
  }

  return (
    <S.DataList>
      {parameters.map((parameter) => (
        <DataEntry
          key={parameter?.title}
          title={parameter?.title}
          value={parameter?.value}
          icon={iconMapper(parameter?.icon)}
        />
      ))}
    </S.DataList>
  );
};

type DataEntryProps = {
  title?: string;
  value?: string;
  icon?: React.ReactElement;
};

const DataEntry = ({ title, value, icon }: DataEntryProps) => (
  <S.Entry>
    <S.IconContainer>{icon}</S.IconContainer>
    <S.Label variant={TextVariant.ArticleText}>{title}</S.Label>
    <S.Value variant={TextVariant.ArticleTextHeader}>{value}</S.Value>
  </S.Entry>
);

export { ProductData };
